import type { FaireProductEntity } from "../../entity_types/product";

export const p_kk6fnjsnfv: FaireProductEntity = {
  token: "p_kk6fnjsnfv",
  type: "product",
  name: "Candied Cashews, 4.0 oz.",
  brandToken: "b_f0wtyxk4dn",
  brandName: "Chesebro's Handmade Confections and Candy",
  imageUrl:
    "https://cdn.faire.com/fastly/b8761871eefbbf9e355b9fe949271dcc31021a37ae3f2f3e89fcd953e9699d56.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fc528cb89f4990ddf7205f6e4df3dc66af92d87a30cdff3a2f4cb0a8a3e03fcf.png",
  ],
  priceDollars: 5.54,
  description:
    "We slow roast each batch of our cashews with just the right amount of sugar, cinnamon and vanilla to make the perfect snackable treat! Each 4 ounce bag is carefully packaged by hand to ensure the best possible quality.\n\nThese delectable nuts have so many great uses:\n\nEat them right our of the bag!\nAdd them to a salad as a gourmet topping with just the right amount of crunch!\nFeeling adventurous? Mix them with other yummies in a homemade trail mix!\nYams and sweet potatoes - sprinkle them on top of baked, mashed or a casserole!\nOur candy is cooked in a copper kettle with top quality ingredients before being formed by vintage equipment. We're proud to say our candies are family made in the USA!\n\nManufactured in a facility that processes tree nuts, peanuts, dairy and soy products. Do not eat if you have allergies to these products.",
  tags: [],
  msrpDollars: 11.02,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:50.054Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
